import { render, staticRenderFns } from "./ForestVision2020French.vue?vue&type=template&id=11aa9ce4&scoped=true"
import script from "./ForestVision2020French.vue?vue&type=script&lang=js"
export * from "./ForestVision2020French.vue?vue&type=script&lang=js"
import style0 from "./ForestVision2020French.vue?vue&type=style&index=0&id=11aa9ce4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11aa9ce4",
  null
  
)

export default component.exports